import FormType from "../../../../../shared/components/FormType";
import { basicFields } from "../../../../../configs/customer";
import React from "react";
import { CustomerFormContainer } from "./Styled";

interface ContactPersonProps {
  onChangeContactPerson: Function;
  validated: boolean;
}

const ContactPerson = ({
  onChangeContactPerson,
  validated,
}: ContactPersonProps) => {
  return (
    <CustomerFormContainer>
      <FormType
        title={"Thông tin khách hàng"}
        mergeFormData={onChangeContactPerson}
        fields={basicFields}
        validated={validated}
      />
    </CustomerFormContainer>
  );
};

export default ContactPerson;
